
export default {
  // 因日志模块与其他页面不同端口，在切换环境时需要在/src/axios/request.js拦截器中修改地址
  // // 正式
  baseUrl: 'http://219.226.0.6/ssoManager', //正式环境地址,
  baseUrlLog: 'http://219.226.0.6/oa-logging',
  toUrl: "http://219.226.0.6", //正式环境地址,

  // 测试环境
  // baseUrl: 'http://192.168.20.80:8085', //地址,
  // baseUrlLog: 'http://192.168.20.80:8086/oa-logging',
  // toUrl: "http://192.168.20.80",

  // 本地
  // baseUrl: 'http://localhost:8080/web', //地址,
  // toUrl: "http://localhost:8081",
 
}


//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = null
// module chunks = 